import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import {
  selectCockpitAttentionOwnersByPartner,
  selectCockpitAttentionPartners,
} from '../../../model/selectors'
import { countAttentionPbms } from '../lib'

/**
 * How many PBMs own the partners the tile's counts stand against, said beside that partner count.
 * The single-partner cockpit has no such base, so there it is `0`.
 */
export const useAttentionScopePbmCount = (isManagerCockpitMode: boolean): number => {
  const partners = useSelector(selectCockpitAttentionPartners)
  const ownersByPartner = useSelector(selectCockpitAttentionOwnersByPartner)

  return useMemo(
    () =>
      isManagerCockpitMode
        ? countAttentionPbms(
            partners.map(({ partnerId }) => partnerId),
            ownersByPartner
          )
        : 0,
    [isManagerCockpitMode, ownersByPartner, partners]
  )
}
